// extracted by mini-css-extract-plugin
export var cards = "FT++1";
export var colorConfiguration = "Tyql9";
export var fullRow = "oZ65d";
export var hero = "ltkeX";
export var iconFeatures = "Fk-0d";
export var introCards = "BOPRY";
export var main = "QKcgP";
export var makeItYoursActions = "nbYU9";
export var makeItYoursContent = "_4hO86";
export var makeItYoursIntro = "TnbH3";
export var technicalDrawingModal = "huJUf";
export var technicalSpecsContent = "O-Gt-";
export var technicalSpecsDrawing = "_9VG+s";
export var technicalSpecsExpandIcon = "ke+RT";
export var video = "d0aEf";